import { render, staticRenderFns } from "./PageAbout.vue?vue&type=template&id=c41df9f4&scoped=true&"
import script from "./PageAbout.vue?vue&type=script&lang=js&"
export * from "./PageAbout.vue?vue&type=script&lang=js&"
import style0 from "./PageAbout.vue?vue&type=style&index=0&id=c41df9f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c41df9f4",
  null
  
)

export default component.exports